// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_a1f47c9a rdg_09d341fe","label":"rdg_9e5bd3ef"};